import script from "./DesktopTiktokAccountsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopTiktokAccountsTable.vue?vue&type=script&setup=true&lang=js"

import "./DesktopTiktokAccountsTable.vue?vue&type=style&index=0&id=b83554f8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b83554f8"]])

export default __exports__